// Wrap axios
import axios from 'axios';
import { config } from './config';


const LOCAL_ENV = "https://localhost:8880";
//const ENV = "https://10.101.3.22:8880";
const HTTPS = "https://";
const PORT = ":8880";

// Instance
// Config the baseURL based on the env
const httpLogin = axios.create({
  //baseURL: ENV,
  baseURL: config.baseUrl,
  //baseURL: HTTPS + window.location.hostname,
  timeout: 20000
});


// header config for json
//http.defaults.headers.post['Content-Type'] = 'application/json';

// header config for form data
//http.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// request interceptor: inject token
// http.interceptors.request.use((config) => {

//   const loginInfo = useSelector(state => state.loginInfo);
//   const token = loginInfo.token;

//   if (token && token !== "") {
//     config.headers.Authorization = token;
//   }

//   return config
// }, (error) => {
//   return Promise.reject(error)
// });

// Response interceptor
httpLogin.interceptors.response.use((response) => {

  return response;
}, (error) => {

  console.dir(error)
  if (error.response.status === 500) {
    //console.log('back to login')
    // or use history to replace browser router
    //window.location.href = 'http://localhost:3000/login'
  }

  return Promise.reject(error)
})

export { httpLogin }